import reduce from 'lodash/reduce';
import forEach from 'lodash/forEach';
import result from 'lodash/result';

export const getSliderMedias = (report) => {
  const reportMedias = [
    ...report.videos.map((video) => ({ ...video, type: 'video' })),
    ...report.images.map((image) => ({ ...image, type: 'image' })),
  ];

  const reportContentsMedias = reduce(report.contents, (acc, content) => {
    forEach(content.videos, (contentVideo) => {
      acc.push({ ...contentVideo, type: 'video' });
    });
    forEach(content.images, (contentImage) => {
      acc.push({ ...contentImage, type: 'image' });
    });
    return acc;
  }, []);

  return [
    ...reportMedias,
    ...reportContentsMedias,
  ];
};

const getReportContentMedias = (reportContent) => {
  const reportContentVideos = reportContent.videos.map((video) => ({
    ...video,
    type: 'video',
    answer: reportContent.answer,
    category: reportContent.question.category.name,
    question: reportContent.question.name,
    rate: reportContent.rate,
  }));

  const reportContentImages = reportContent.images.map((image) => ({
    ...image,
    type: 'image',
    answer: reportContent.answer,
    category: reportContent.question.category.name,
    question: reportContent.question.name,
    rate: reportContent.rate,
  }));

  return [
    ...reportContentVideos,
    ...reportContentImages,
  ];
};

export const getReportContentsMediasGroupByField = (reportContents, field) => {
  const { groupByField, all } = reduce(reportContents, (acc, reportContent) => {
    const reportContentMedias = getReportContentMedias(reportContent);
    if (result(acc.groupByField, `${result(reportContent, field)}`)) {
      acc.groupByField[result(reportContent, field)].push(...reportContentMedias);
    } else {
      acc.groupByField[result(reportContent, field)] = reportContentMedias;
    }

    acc.all.push(...reportContentMedias);

    return acc;
  }, { groupByField: {}, all: [] });

  return { groupByField, all };
};
